import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { NotificacoesListComponent } from "./notificacoes-list/notificacoes-list.component";
import { AvisosListComponent } from "./avisos-list/avisos-list.component";
import { NotificationService } from '../../services/notification/notification.service';
import { pushPaginaAtiva, clearPaginas } from '../../shared/activePage';

@Component({
  selector: 'app-notificacoes',
  imports: [
    CommonModule,
    NotificacoesListComponent,
    AvisosListComponent
  ],
  templateUrl: './notificacoes.html',
  styleUrl: './notificacoes.scss'
})
export class Notificacoes implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  isNotificacoesActive: boolean = true;
  unreadAvisosCount = 0;
  unreadNotificacoesCount = 0;

  constructor(private notificationService: NotificationService) { }

  ngOnInit(): void {
    clearPaginas();
    pushPaginaAtiva({
        nome: 'Home',
        rota: '/home'
    });
    pushPaginaAtiva({
        nome: 'Notificações',
        rota: ''
    });

    this.notificationService.unreadAvisosCount$
      .pipe(takeUntil(this.destroy$))
      .subscribe(count => {
        this.unreadAvisosCount = count;
      });
    this.notificationService.unreadNotificacoesCount$
      .pipe(takeUntil(this.destroy$))
      .subscribe(count => {
        this.unreadNotificacoesCount = count;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleActiveScreen(boolean: boolean) {
    this.isNotificacoesActive = boolean;
  }
}
